import { Component } from '@angular/core';
import { ToggleService } from '../../../app/components/common/header/toggle.service';
import { CustomizerSettingsService } from '../../../app/components/customizer-settings/customizer-settings.service';
import { AuthenticationService } from 'app/authentication/service';
import { menuGroups } from 'app/menu/menu';
import { CoreMenuGroup } from '@core/types';
import { Helper } from '@core/util/helper';

@Component({
  selector: 'core-sidebar',
  templateUrl: './core-sidebar.component.html',
  styleUrls: ['./core-sidebar.component.scss'],
})
export class CoreSidebarComponent {
  panelOpenState = false;
  currentUser: any;
  menuGroups: CoreMenuGroup[];
  isToggled = false;

  constructor(
    private toggleService: ToggleService,
    public themeService: CustomizerSettingsService,
    private _authenticationService: AuthenticationService
  ) {
    // Set the private defaults
    this.menuGroups = menuGroups;
    this._authenticationService.currentUser.subscribe((x) => (this.currentUser = x));
    this.toggleService.isToggled$.subscribe((isToggled) => {
      this.isToggled = isToggled;
    });
  }

  showElement(item): boolean {
    // Staff logins: never show Partner list or Staff management in the sidebar (partner-owner only).
    if (this.currentUser?.loginType === 'staff' && item?.type === 'item' && item?.url) {
      if (item.url === '/partners/partner' || item.url === '/partners/staff') {
        return false;
      }
    }
    // Partners collapsible: for staff, only show if at least one child is visible (Partner/Staff hidden above).
    if (this.currentUser?.loginType === 'staff' && item?.type === 'collapsible' && item.id === 'partners') {
      return !!(item.children?.some((ch) => this.showElement(ch)));
    }

    // Admin partner type (`partnerType === 'admin'`): never show Staff management (matches API — admin cannot manage staff).
    if (this.currentUser?.loginType !== 'staff' && this.currentUser?.partnerType === 'admin' && item?.type === 'item' && item?.url === '/partners/staff') {
      return false;
    }
    if (this.currentUser?.loginType !== 'staff' && this.currentUser?.partnerType === 'admin' && item?.type === 'collapsible' && item.id === 'partners') {
      return !!(item.children?.some((ch) => this.showElement(ch)));
    }

    const userPermissions = Helper.effectiveUserPermissions(this.currentUser);
    const filteredPermission = item.permissions?.filter((value) => userPermissions?.includes(value));
    return filteredPermission && filteredPermission.length > 0;
  }

  // A group's square is shown when it is locked (always visible as a teaser)
  // or when at least one of its children is visible for the current user.
  showGroup(group: CoreMenuGroup): boolean {
    if (group?.locked) {
      return true;
    }
    return !!group?.children?.some((item) => {
      if (item.permissions && item.permissions.length > 0) {
        return this.showElement(item);
      }
      // Items without permissions are always visible.
      return true;
    });
  }

  toggle() {
    this.toggleService.toggle();
  }

  toggleSidebarTheme() {
    this.themeService.toggleSidebarTheme();
  }

  toggleHideSidebarTheme() {
    this.themeService.toggleHideSidebarTheme();
  }
}
